/* import __COLOCATED_TEMPLATE__ from './anchor-editor.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { findMark, getMarkBounds } from '@intercom/embercom-prosemirror-composer/lib/helpers/selection';
import { TextSelection } from 'prosemirror-state';
import { next } from '@ember/runloop';
import { cleanUrl } from '@intercom/embercom-prosemirror-composer/lib/helpers/clean-url';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let AnchorEditor = (_dec = ref('hrefInput'), (_class = class AnchorEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "hrefInput", _descriptor, this);
  }
  get attributeInfoResolver() {
    return this.args.composer.config.templating?.resolver;
  }
  get schema() {
    return this.args.composer.state.prosemirrorState.schema;
  }
  get anchorMarkType() {
    return this.schema.marks.anchor;
  }
  get href() {
    return this.anchorMark?.attrs.href;
  }
  get $from() {
    return this.args.composer.state.prosemirrorState.selection.$from;
  }
  get isCaretWithinAnchor() {
    return this.args.composer.state.selectionIsEmpty && this.args.composer.state.selectionHasMark('anchor');
  }
  get anchorMark() {
    if (!this.$from) {
      return;
    }
    return findMark(this.$from, this.anchorMarkType);
  }
  get anchorPosition() {
    let anchorMark = this.anchorMark;
    if (!anchorMark) {
      return {
        from: 0,
        to: 0
      };
    }
    return getMarkBounds(this.args.composer.state.prosemirrorState.doc, anchorMark);
  }
  get inputIsBlank() {
    return !this.hrefInput.value;
  }
  focusIfEmpty(element) {
    if (isEmpty(this.href)) {
      next(this, () => {
        element.focus();
      });
    }
  }
  onInsert(attributeTemplate, attributeTemplateStartPosition = 0, attributeTemplateEndPosition = 0) {
    if (this.hrefInput) {
      this.setSelectionRange(this.hrefInput, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition);
    }
  }
  update() {
    if (!this.anchorMark) {
      return;
    }
    let href = cleanUrl(this.hrefInput.value);
    let newMark = this.anchorMarkType.create({
      href
    });
    let transaction = this.args.composer.state.prosemirrorState.tr.addMark(this.anchorPosition.from, this.anchorPosition.to, newMark);
    if (transaction) {
      this.args.composer.commands.dispatch(transaction);
    }
  }
  remove() {
    let transaction = this.args.composer.state.prosemirrorState.tr.removeMark(this.anchorPosition.from, this.anchorPosition.to, this.anchorMark);
    if (transaction) {
      this.args.composer.commands.dispatch(transaction);
    }
    next(this, () => {
      this.args.composer.commands.focus();
    });
  }
  onKeyUp(e) {
    if (e.key === 'Enter' || e.code === 'Escape') {
      this.update();
      if (!this.inputIsBlank) {
        this._moveSelectionToEndOfAnchor();
      }
      next(this, () => {
        this.args.composer.commands.focus();
      });
    }
  }
  _moveSelectionToEndOfAnchor() {
    let tr = this.args.composer.state.prosemirrorState.tr;
    if (tr) {
      tr.setSelection(TextSelection.create(tr.doc, this.anchorPosition.to));
      this.args.composer.commands.dispatch(tr);
    }
  }
  setSelectionRange(inputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition) {
    let targetStartPosition = inputElement.value.length + attributeTemplateStartPosition;
    let targetEndPosition = inputElement.value.length + attributeTemplateEndPosition;
    inputElement.value += attributeTemplate;
    inputElement.focus();
    inputElement.setSelectionRange(targetStartPosition, targetEndPosition);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "hrefInput", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "focusIfEmpty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusIfEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "remove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyUp"), _class.prototype)), _class));
export { AnchorEditor as default };